// !FIXME - Easy - Flow type this file

import React from 'react'
import { Header } from 'semantic-ui-react'
import { prussian, silver, platinum } from 'constants/inlineStyles'

import FlyerPages from './components/ImageBody'
import SchoolList from './components/SchoolList'
// import RelatedFlyers from './components/RelatedFlyers'

let styles = {}

const FlyerDetailBody = ({ flyer, schools }) =>
  flyer && (
    <div style={styles.flyerDetailBodyWrapper}>
      <div className="flyer-detail-body">
        <Header
          as="h1"
          content={flyer.title}
          style={styles.header}
          data-testid="flyer-title"
        />
        {flyer.pages && (
          <FlyerPages
            flyer={flyer}
            pages={flyer.pages}
            flyerTitle={flyer.title}
            category={flyer.category}
            senderEmail={flyer.seller_email}
            description={flyer.description}
          />
        )}
        <p data-testid="flyer-id">Flyer ID {flyer.flyer_id}</p>
        <SchoolList schools={schools} />
        {/* <RelatedFlyers /> */}
      </div>
    </div>
  )

styles = {
  flyerDetailBodyWrapper: {
    padding: '1rem',
    backgroundColor: platinum,
    border: `1px solid ${silver}`,
    borderTop: 'none',
    color: prussian
  },
  header: {
    fontSize: '1.6rem',
    lineHeight: '1.1',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    color: prussian,
    marginTop: '.3333rem',
    marginBottom: '1.3333rem'
  }
}

export default FlyerDetailBody



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailBody/index.js